<script>
    import {
        Chart as ChartJS,
        ArcElement,
        Colors,
    } from 'chart.js';
    import { Doughnut } from 'vue-chartjs';

    import ChartDataLabels from 'chartjs-plugin-datalabels';
    import ChartDoughnutLabels from 'chartjs-plugin-doughnutlabel-rebourne';

    ChartJS.register(
        ArcElement,
        Colors,
        ChartDataLabels,
        ChartDoughnutLabels,
    );

    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        components: {
            Doughnut,
            Vue3Autocounter,
        },
        props: {
            data: Object,
            showNumber: Boolean,
        },
        data() {
            return {
                facetAliasHeadsum: 'hoofdsom_totaal',
                facetAliasReceived: 'bedrag_door_u_ontvangen_inc_btw_voordeel',
                facetAliasPaid: 'bedrag_door_u_betaald_inc_btw',
                options: {
                    locale: 'nl-NL',
                    cutout: '85%',
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                        },
                        datalabels: {
                            display: false,
                        },
                        title: {
                            display: true,
                            text: this.$store.getters.getText('dashboardWidgetEfficiencysign'),
                        },
                    },
                }
            }
        },
        computed: {
            dataSet() {
                return this.data && this.data.sums;
            },
            dataSets() {
                const defaultValue = { labels: [], datasets: [] };
                if (!this.dataSet) return defaultValue;

                const sumReceived = this.data.sums[this.facetAliasReceived] || 0;
                const sumPaid = this.data.sums[this.facetAliasPaid] || 0;
                const headSum = this.data.sums[this.facetAliasHeadsum] || 0;

                const percentage = headSum !== 0 ? Math.round((sumReceived + sumPaid) / headSum * 100) : 0;

                const labels = [this.$store.getters.getText('dashboardWidgetEfficiency')];
                const data = [percentage];
                const backgroundColor = this.$store.getters.getHighContrast ? '#833de6' : '#53b7d8';

                return {
                    labels: labels,
                    datasets: [{
                        data: data,
                        backgroundColor: backgroundColor,
                    }],
                };
            },
            computedOptions() {
                if (!this.dataSets.datasets.length || !this.dataSets.datasets[0].data.length) return this.options;
                return {
                    ...this.options,
                    plugins: {
                        ...this.options.plugins,
                        doughnutlabel: {
                            labels: [
                                {
                                    text: `${this.dataSets.datasets[0].data[0]}%`,
                                    font: {
                                        size: '16',
                                    },
                                },
                            ]
                        },
                    },
                };
            },
        },
    };
</script>

<template>
    <div class="dashboard-widget">
        <div v-if="!showNumber" class="columns is-mobile is-centered is-multiline">
            <div class="column is-half">
                <Doughnut :data="dataSets" :options="computedOptions" />
            </div>
        </div>
        <div v-else class="block is-fullheight is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetEfficiency') }}</span>
            <span v-if="dataSets.datasets.length && dataSets.datasets[0].data.length"><vue3-autocounter :endAmount="dataSets.datasets[0].data[0]" separator="." duration="0.5" /></span>
        </div>
    </div>
</template>
